const es = {
  "srv_general_unknown": "Algo salió mal. Inténtalo de nuevo.",
  "srv_general_network": "Error de red. Comprueba tu conexión.",
  "srv_general_timeout": "La solicitud agotó el tiempo. Inténtalo de nuevo.",
  "srv_general_not_found": "No encontrado",
  "srv_general_invalid_id": "id no válido",
  "srv_general_invalid_json": "JSON no válido",
  "srv_auth_admin_only": "Solo administradores",
  "srv_auth_owner_only": "Solo acceso del propietario",
  "srv_auth_unauthorized": "No autorizado",
  "srv_auth_not_authenticated": "No autenticado",
  "srv_auth_invalid_token": "Token no válido",
  "srv_auth_session_expired": "No hay token de actualización",
  "srv_auth_token_expired": "Token expirado",
  "srv_auth_device_signed_out": "Se cerró la sesión en este dispositivo",
  "srv_auth_invalid_login": "Nombre de usuario/email o contraseña no válidos",
  "srv_auth_wrong_password": "La contraseña actual es incorrecta",
  "srv_auth_email_already_exists": "El email ya está registrado",
  "srv_auth_email_taken_other": "Ese email ya está en uso por otra cuenta",
  "srv_auth_same_email": "Ese ya es tu email",
  "srv_auth_same_username": "Ese ya es tu nombre de usuario",
  "srv_auth_username_taken": "El nombre de usuario ya está en uso",
  "srv_auth_username_invalid": "El nombre de usuario debe tener 3-20 letras, números o guion bajo",
  "srv_auth_user_not_found": "Usuario no encontrado",
  "srv_auth_password_mismatch": "Las contraseñas no coinciden",
  "srv_auth_password_weak": "La nueva contraseña debe tener al menos 8 caracteres e incluir una letra y un número",
  "srv_auth_password_same": "La nueva contraseña debe ser distinta de la actual",
  "srv_auth_rate_limited": "Demasiados intentos. Inténtalo más tarde.",
  "srv_auth_signup_rate_limited": "Demasiados registros desde esta red. Inténtalo más tarde.",
  "srv_auth_verify_link_invalid": "Enlace de verificación no válido o ya usado",
  "srv_auth_verify_link_expired": "El enlace de verificación expiró. Solicita uno nuevo.",
  "srv_auth_email_already_verified": "El email ya está verificado.",
  "srv_auth_verification_sent": "Email de verificación enviado.",
  "srv_auth_email_change_sent": "Enlace de verificación enviado al nuevo email. Confírmalo para completar el cambio.",
  "srv_auth_reset_link_invalid": "Enlace de restablecimiento no válido o expirado",
  "srv_auth_reset_sent": "Si la cuenta existe, se ha enviado un enlace de restablecimiento.",
  "srv_auth_password_updated": "Contraseña actualizada. Inicia sesión con tu nueva contraseña.",
  "srv_auth_password_changed": "Contraseña cambiada. Vuelve a iniciar sesión en tus otros dispositivos.",
  "srv_auth_signed_out_all": "Sesión cerrada en todos los dispositivos",
  "srv_auth_signed_out_others": "Sesión cerrada en todos los demás dispositivos",
  "srv_auth_device_revoked": "Sesión cerrada en el dispositivo",
  "srv_subscription_required": "Esta función es para miembros Premium",
  "srv_subscription_plan_unavailable": "El plan de prueba no está disponible.",
  "srv_subscription_order_not_found": "Pedido no encontrado",
  "srv_payment_provider_unreachable": "No se pudo contactar al proveedor de pagos. Inténtalo de nuevo.",
  "srv_payment_invoice_failed": "El proveedor de pagos no pudo crear la factura. Inténtalo de nuevo.",
  "srv_payment_not_configured": "La pasarela de pagos crypto aún no está configurada. Añade las claves API de NOWPayments.",
  "srv_payment_invalid_signature": "Firma no válida",
  "srv_exchange_connection_not_found": "Conexión no encontrada",
  "srv_exchange_unsupported": "Exchange no compatible",
  "srv_exchange_unreachable": "No se puede acceder al exchange desde el servidor",
  "srv_exchange_key_not_readonly": "Esta clave API tiene permisos de trading/retiro. Crea una clave de SOLO LECTURA (desactiva Trade y Withdraw).",
  "srv_exchange_verify_first": "Verifica la conexión antes de activar el trading en vivo",
  "srv_insufficient_balance": "El importe supera tu saldo disponible",
  "srv_trade_amount_positive": "El importe debe ser mayor que 0",
  "srv_trade_invalid_withdrawal": "Importe de retiro no válido",
  "srv_trade_bot_needs_tp_sl": "El bot requiere Stop Loss y Take Profit",
  "srv_trade_no_position": "No hay posición abierta para vender",
  "srv_trade_position_not_found": "Posición no encontrada",
  "srv_trade_symbol_required": "El símbolo es obligatorio",
  "srv_trade_invalid_symbol": "Símbolo no válido",
  "srv_trade_invalid_interval": "Intervalo no válido",
  "srv_trade_verify_email": "Verifica tu correo electrónico antes de abrir operaciones.",
  "srv_trade_verify_email_auto": "Verifica tu correo electrónico antes de activar el trading automático.",
  "srv_trade_demo_min": "El saldo mínimo de demo es 100",
  "srv_trade_demo_max": "El saldo de demo es demasiado alto (máx. 10,000,000)",
  "srv_trade_leverage_confirm": "El apalancamiento superior a 20x requiere doble confirmación",
  "srv_trade_high_risk_confirm": "El riesgo superior al 15% requiere confirmación de Alto riesgo",
  "srv_trade_high_liquidation_risk": "Alto riesgo de liquidación",
  "srv_trade_no_fee": "Sin comisión (mantenido 7+ días).",
  "srv_insufficient_data": "No hay suficientes datos de velas para este backtest",
  "srv_notification_not_found": "Notificación no encontrada",
  "srv_nft_image_failed": "Error al generar la imagen",
  "ntf_cloud_enabled": "Trading en la nube activado — el bot funciona 24/7.",
  "ntf_cloud_disabled": "Trading en la nube desactivado.",
  "srv_trade_no_price": "No hay precio disponible para {symbol}",
  "srv_trade_risk_lock": "Bloqueo de riesgo: máx. {pct}% del saldo por operación",
  "srv_trade_max_leverage": "El apalancamiento máximo para {symbol} es {max}x",
  "srv_trade_risk_range": "El riesgo para {symbol} debe estar entre 1% y {max}%",
  "srv_payment_unsupported_currency": "Moneda no compatible. Elige una de: {list}",
  "srv_exchange_unsupported_named": "Exchange no compatible: {name}",
  "srv_auth_username_cooldown": "El nombre de usuario podrá cambiarse de nuevo en {days} día(s)",
  "srv_exchange_connection_error": "Error de conexión: {error}",
  "srv_trade_early_fee": "Se aplicó una comisión de retiro anticipado del 5% ({fee}).",
  "ntf_risk_drawdown": "La reducción máxima de {dd}% alcanzó el límite de {limit}%. Todas las posiciones se cerraron. Bot detenido.",
  "ntf_risk_losses": "{count} pérdidas consecutivas. Bot detenido. Confirma para reanudar.",
  "ntf_cooldown": "En enfriamiento tras {count} pérdidas consecutivas — nuevas entradas pausadas durante {minutes} min.",
  "ntf_trade_opened": "Operación abierta: {symbol} {timeframe} · puntuación {score} · {leverage}",
  "ntf_nft_opened": "Posición NFT abierta (Demo): {name}",
  "ntf_nft_closed": "Posición NFT cerrada (Demo): P&L {pnl}",
  "ntf_trade_closed": "{reason}: {symbol} cerrada · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · Puntuación {score}. Entrada ${entry} / TP ${tp} / SL ${sl}. Solo informativo — no es asesoramiento financiero.",
  "app_name": "FIREBIRD AI",
  "tagline": "Trading de cripto y NFT con IA",
  "login": "Iniciar sesión",
  "register": "Registrarse",
  "logout": "Cerrar sesión",
  "email": "Correo electrónico",
  "password": "Contraseña",
  "name": "Nombre",
  "welcome_back": "Bienvenido de nuevo, trader",
  "create_account": "Crea tu cuenta",
  "no_account": "¿Aún no tienes cuenta?",
  "have_account": "¿Ya tienes una cuenta?",
  "account_created": "Cuenta creada — demo de $100 lista",
  "loading": "Cargando…",
  "demo_mode": "Modo demo",
  "demo_balance": "Saldo demo",
  "nav_dashboard": "Panel",
  "nav_charts": "Gráficos en vivo",
  "nav_signals": "Señales de IA",
  "nav_autotrade": "Trading automático",
  "nav_manual": "Trading manual",
  "nav_scanner": "Escáner de memecoins",
  "nav_backtest": "Backtest 5×5",
  "nav_positions": "Posiciones e informes",
  "nav_nft": "Colección NFT",
  "nav_assistant": "Asistente de IA",
  "nav_settings": "Exchange y ajustes",
  "nav_subscription": "Plan Premium",
  "subscription_subtitle": "Desbloquea inteligencia de trading premium — paga con cripto.",
  "current_plan": "Plan actual",
  "premium": "Prémium",
  "free_plan": "Plan gratuito",
  "renews_on": "Se renueva el",
  "active": "Activo",
  "best_value": "Mejor valor",
  "plan_monthly": "Mensual",
  "plan_annual": "Anual",
  "plan_test": "Prueba",
  "days": "días",
  "pay_with_crypto": "Pagar con cripto",
  "opening_checkout": "Abriendo el pago…",
  "gateway_not_ready": "La pasarela de pago cripto aún no está configurada. El pago Premium se habilitará cuando se agreguen las claves API de NOWPayments.",
  "premium_only": "Solo Premium",
  "premium_gate_desc": "Esta función es parte de FireBird Premium. Mejora tu plan para desbloquear todas las señales de IA, el auto-trade y el escáner de oportunidades.",
  "go_premium": "Pasar a Premium",
  "billing_history": "Historial de facturación",
  "no_invoices": "Aún no hay facturas. Tus pagos en cripto aparecerán aquí.",
  "date": "Fecha",
  "plan_col": "Plan",
  "amount_col": "Importe",
  "status_col": "Estado",
  "view_invoice": "Ver factura",
  "check_status": "Comprobar estado del pago",
  "checking": "Comprobando…",
  "payment_still_pending": "El pago aún no está confirmado. Seguiremos comprobando automáticamente.",
  "status_paid": "Pagado",
  "status_created": "Pendiente",
  "status_partially_paid": "Pago parcial",
  "status_expired": "Expirado",
  "status_failed": "Fallido",
  "status_refunded": "Reembolsado",
  "status_cancelled": "Cancelado",
  "status_canceled": "Cancelado",
  "payment_processing": "Pago detectado — activando tu plan Premium…",
  "payment_success": "Premium activado. ¡Bienvenido a bordo!",
  "payment_cancelled": "Pago cancelado.",
  "payment_error": "No se pudo iniciar el pago. Inténtalo de nuevo.",
  "popup_blocked": "El pago está listo. Si no se abrió una pestaña nueva, usa el enlace de abajo.",
  "checkout_opened_hint": "El pago se abrió en una pestaña nueva. ¿No la ves?",
  "open_checkout": "Abrir pago",
  "pay_currency_label": "Pagar con",
  "pay_currency_hint": "Aceptamos USDC en Solana y BNB en BSC. El activo elegido se fija al pagar.",
  "feat_signals": "Señales de IA completas (Cripto, Shitcoins, NFT)",
  "feat_autotrade": "Auto-Trade con gestión de riesgo",
  "feat_scanner": "Escáner de memecoins y oportunidades",
  "feat_alerts": "Alertas inteligentes por correo",
  "feat_priority": "Entrega prioritaria de señales",
  "feat_save": "2 meses gratis frente al plan mensual",
  "feat_test_quick": "Prueba única de $1 — verifica el flujo de pago real",
  "demo_account_settings": "Ajustes de la cuenta demo",
  "demo_settings_desc": "Establece un saldo demo personalizado y restablece tu cuenta de paper trading. Esto solo afecta a los datos demo: nunca toca tu suscripción ni ningún trading real.",
  "custom_demo_balance": "Saldo demo personalizado (USDC)",
  "demo_min_hint": "Por defecto 500 · mínimo 100",
  "reset_demo_account": "Restablecer cuenta demo",
  "reset_demo_confirm_title": "¿Restablecer la cuenta demo?",
  "reset_demo_confirm_desc": "Esto establece tu saldo demo en ${bal}, elimina todas las operaciones demo y el historial de P/L, y borra el estado de drawdown, pausa y enfriamiento. No se puede deshacer. Tu suscripción y tus datos reales no se ven afectados.",
  "demo_reset_done": "Cuenta demo restablecida — saldo establecido en ${bal}",
  "demo_min_balance_error": "El saldo demo mínimo es 100",
  "nav_guide": "Guía para principiantes",
  "owner_console": "Consola del propietario",
  "total_value": "Valor total",
  "cash": "Efectivo",
  "holdings": "Tenencias",
  "unrealized_pnl": "PnL no realizado",
  "top_signals": "Mejores señales de IA",
  "market_overview": "Resumen del mercado",
  "whale_activity": "Ballenas y dinero inteligente",
  "market_pulse": "Pulso del mercado",
  "news_up": "{name} sube un {pct}% en 24 h",
  "news_down": "{name} baja un {pct}% en 24 h",
  "kind_cex": "CEX",
  "kind_iranian_cex": "CEX iraní",
  "kind_dex": "DEX",
  "price": "Precio",
  "change_24h": "24 h",
  "score": "Puntuación",
  "action": "Acción",
  "buy": "Comprar",
  "sell": "Vender",
  "hold": "Mantener",
  "timeframe": "Marco temporal",
  "symbol": "Símbolo",
  "amount_usd": "Importe (USD)",
  "open_position": "Abrir posición",
  "close": "Cerrar",
  "no_positions": "No hay posiciones abiertas",
  "entry": "Entrada",
  "current": "Actual",
  "exit": "Salida",
  "reason": "Motivo",
  "pnl": "PnL",
  "win_rate": "Tasa de acierto",
  "total_trades": "Operaciones totales",
  "total_pnl": "PnL total",
  "wl": "G / P",
  "open_label": "Abierta",
  "run_backtest": "Ejecutar backtest",
  "running": "Ejecutando…",
  "bt_subtitle": "Estrategia probada en 5 ventanas históricas por marco temporal.",
  "window_results": "Resultados por ventana",
  "window": "Ventana",
  "trades": "Operaciones",
  "return_label": "Rentabilidad",
  "max_drawdown": "Drawdown máximo",
  "auto_trade_on": "Auto-Trade activo",
  "auto_trade_off": "Auto-Trade desactivado",
  "enable_autotrade": "Activar Auto-Trade (demo)",
  "reset_demo": "Restablecer demo ($100)",
  "activity_log": "Registro de actividad",
  "waiting_signals": "Esperando señales…",
  "enable_to_start": "Activa el auto-trade para empezar",
  "reauthorize_bot": "Reautorizar bot",
  "leverage": "Apalancamiento",
  "high_leverage_warning": "Apalancamiento alto — puedes perder todo tu margen (liquidación).",
  "bot_description": "El bot analiza todas las monedas en 15m / 1h / 4h, entra con la mejor señal (riesgo:beneficio 2:1, stop obligatorio) y gestiona las posiciones con take-profit móvil en modo demo.",
  "rule_rr": "Beneficio:Riesgo 2:1 (stop obligatorio)",
  "rule_max_concurrent": "Máx. 2 auto-trades simultáneos",
  "rule_leverage": "Apalancamiento auto ≤ 10x · Manual ≤ 50x",
  "rule_circuit": "Cortacircuitos con un 20% de drawdown",
  "rule_halt": "Pausa tras 5 pérdidas",
  "rule_scan": "Analiza todas las monedas y marcos temporales",
  "rule_entry": "Puntuación de entrada ≥ {score} en {tfs}",
  "rule_cooldown": "Enfriamiento de {min} min tras {losses} pérdidas",
  "risk_status": "Estado del riesgo",
  "risk_mode_active": "Activo",
  "risk_mode_halted": "Detenido",
  "consecutive_losses_label": "Pérdidas consecutivas",
  "drawdown_label": "Reducción",
  "open_positions_label": "Posiciones abiertas",
  "max_concurrent_reached": "Se alcanzó el máximo de operaciones simultáneas.",
  "bot_reauthorized": "Bot reautorizado. Ya puedes activar el auto-trade de nuevo.",
  "cloud_trading": "Trading en la nube",
  "enable_cloud": "Activar trading en la nube",
  "disable_cloud": "Desactivar trading en la nube",
  "cloud_status": "Estado de la nube",
  "cloud_on": "En ejecución 24/7",
  "cloud_off": "Apagado",
  "cloud_desc": "El bot se ejecuta en nuestros servidores 24/7, incluso con tu dispositivo apagado.",
  "notifications": "Notificaciones",
  "no_notifications": "Aún no hay notificaciones",
  "mark_all_read": "Marcar todo como leído",
  "connect_exchange": "Conectar exchange",
  "api_key": "Clave API",
  "api_secret": "Secreto API",
  "api_key_optional": "Clave API (opcional para precios públicos)",
  "connect": "Conectar",
  "test": "Probar",
  "remove": "Quitar",
  "verified": "Verificado",
  "not_verified": "No verificado",
  "connected_exchanges": "Exchanges conectados",
  "aggregated_balances": "Saldos · Todos los exchanges",
  "aggregated_prices": "Precios en vivo · Todos los exchanges",
  "no_connections": "Aún no hay exchanges conectados.",
  "connect_wallet": "Conectar wallet",
  "wallet_connected": "Wallet conectada",
  "wallet_note": "Sin custodia — nunca guardamos tus claves privadas.",
  "wallet_security": "Wallet y seguridad",
  "wallet_never_ask": "Nunca te pedimos tu clave privada ni tu frase semilla.",
  "disconnect_wallet": "Desconectar wallet",
  "switch_chain": "Cambiar de red",
  "native_balance": "Saldo nativo",
  "wallet_chain": "Red",
  "dex_onchain": "DEX (on-chain)",
  "sign_in_wallet": "Iniciar sesión con la wallet",
  "waiting_signature": "Esperando la firma de la wallet…",
  "dex_demo_note": "Firmas con tu propia wallet — las claves nunca salen de tu dispositivo.",
  "view_on_explorer": "Ver en el explorador",
  "wallet_required_dex": "Conecta tu wallet para operar on-chain.",
  "tx_pending": "Transacción pendiente…",
  "tx_confirmed": "Transacción confirmada",
  "tx_failed": "Transacción fallida",
  "connected_label": "Conectado",
  "not_connected_label": "No conectado",
  "copy_address": "Copiar dirección",
  "readonly_warning": "Crea tu clave API con permisos de SOLO LECTURA. Desactiva Retirar y Operar.",
  "cex_security_notice": "NUNCA guardamos tus claves privadas ni pedimos permisos de retiro.",
  "api_passphrase_optional": "Frase de contraseña (opcional)",
  "read_only_label": "Solo lectura",
  "how_to_create_key": "Cómo crear una clave de solo lectura",
  "connected_wallets": "Wallets conectadas",
  "no_wallet_connected": "No hay ninguna wallet conectada.",
  "no_exchange_linked": "No hay ningún exchange vinculado.",
  "smart_contract_allowances": "Permisos de contratos inteligentes",
  "no_allowances": "No hay permisos activos.",
  "revoke": "Revocar",
  "max_spend": "Gasto máximo",
  "link_readonly_hint": "Usa el panel Conectar exchange para vincular una clave de solo lectura.",
  "vpn_notice": "Este marketplace puede requerir una VPN para usuarios de algunas regiones.",
  "ir_friendly": "Apto para Irán",
  "best_price": "Mejor precio",
  "marketplace_listings": "Anuncios del marketplace",
  "tab_opps": "Oportunidades",
  "opportunities": "Oportunidades",
  "high_opportunity": "Oportunidad alta",
  "alerts_triggered_today": "alertas activadas hoy",
  "score_range": "Rango de puntuación",
  "timeframe_label": "Marco temporal",
  "direction_label": "Dirección",
  "risk_disclaimer_title": "Aviso de riesgo",
  "risk_disclaimer": "Las señales son solo informativas. NO son asesoramiento financiero. El 98% de las shitcoins fracasan. Usa siempre Stop Loss. Nunca arriesgues más del 1-5% por operación.",
  "no_opportunities": "No hay oportunidades ahora mismo. El escáner se ejecuta cada 5 minutos.",
  "alerts_title": "Alertas",
  "enable_scanner": "Activar escáner automático",
  "min_score_label": "Puntuación mínima",
  "monitor_timeframes": "Marcos temporales a monitorizar",
  "max_alerts_day": "Máx. de alertas por día",
  "notify_method_label": "Método de notificación",
  "notify_in_app": "Solo en la app",
  "notify_in_app_email": "En la app + correo",
  "alert_history_title": "Historial de alertas",
  "no_alert_history": "Aún no hay alertas.",
  "nft_markets": "Marketplaces de NFT",
  "iran_friendly": "Apto para Irán",
  "key_security_note": "Las claves se cifran en el servidor y nunca se guardan en tu navegador.",
  "exchange": "Intercambio",
  "no_balances": "Sin saldos (añade claves API para cargar los saldos reales).",
  "safety": "Seguridad",
  "opportunity": "Oportunidad",
  "holders": "Titulares",
  "verdict": "Veredicto",
  "coin": "Moneda",
  "chain": "Cadena",
  "scanning": "Escaneando…",
  "scanner_subtitle": "Memecoins seleccionadas con liquidez operable (puntuación ≥ 75). No se muestran tokens desconocidos ni fraudulentos.",
  "safety_note": "Seguridad = bloqueo de liquidez + renuncia al mint + distribución de holders (orientativo, no es asesoramiento financiero).",
  "ask_ai": "Pregunta a Firebird AI...",
  "send": "Enviar",
  "chat": "Chat",
  "ai_empty": "Pregunta sobre una moneda, un marco temporal o una estrategia. Nada es asesoramiento financiero.",
  "ai_thinking": "Firebird AI está pensando…",
  "ai_error": "Lo siento, no pude responder en este momento.",
  "score_coin": "Puntuar esta moneda",
  "any_coin_symbol": "Cualquier símbolo de moneda",
  "analyzing": "Analizando…",
  "entry_strategy": "Entrada",
  "exit_strategy": "Salida",
  "risk": "Riesgo",
  "signals_subtitle": "IA + puntuación técnica en todas las monedas",
  "momentum": "Impulso",
  "simulated_feed": "feed simulado",
  "collection": "Colección Firebird 555",
  "nft_subtitle": "Firebird / Fénix — 555 piezas · 6 raras legendarias · cada una con su propia historia de destrucción y renacimiento",
  "rares": "Raras legendarias",
  "floor_price": "Precio mínimo",
  "minted": "Acuñados",
  "total_supply": "Suministro total",
  "rarity": "Rareza",
  "bt_download": "Descargar",
  "bt_stop_loss": "Límite de pérdidas (TP = 2× SL)",
  "bt_min_score": "Puntuación mín. de señal",
  "bt_share": "Compartir",
  "bt_history": "Ejecuciones de backtest guardadas",
  "bt_card_saved": "Tarjeta de resultados descargada",
  "bt_compare_tf": "Comparar marcos temporales",
  "bt_best": "MEJOR",
  "bt_worst": "PEOR",
  "bt_run_all": "Ejecutar todas las monedas",
  "bt_by_section": "Resultados por sección",
  "bt_per_coin": "Resultados por moneda",
  "bt_avg_return": "Rentabilidad media",
  "bt_skipped": "Omitido (datos insuficientes)",
  "bt_sec_major": "Principales",
  "bt_sec_shitcoin": "Moneda basura",
  "bt_sec_meme": "Meme",
  "bt_sec_nft": "Tokens NFT",
  "bt_sec_other": "Otros",
  "bt_data_live": "datos de mercado EN VIVO",
  "bt_data_simulated": "datos SIMULADOS (mercado en vivo no disponible)",
  "risk_per_trade": "Riesgo por operación",
  "max_amount": "Máx.",
  "tier_major": "Principal",
  "tier_mid": "Mediana capitalización",
  "tier_meme": "Meme/Impulso",
  "high_risk_ack": "Entiendo que esta es una operación de Alto Riesgo (más del 15% de mi saldo).",
  "lev_warn_yellow": "Alto riesgo de liquidación",
  "lev_warn_red": "Apalancamiento extremo — riesgo de liquidación muy alto. Se requiere doble confirmación.",
  "lev_ack": "Entiendo que puedo perder todo mi margen.",
  "lev_confirm_again": "Apalancamiento extremo: pulsa de nuevo para confirmar.",
  "confirm_again": "Confirmar de nuevo",
  "high_risk_required": "Marca la confirmación de Alto Riesgo.",
  "lev_ack_required": "Confirma la advertencia de apalancamiento extremo.",
  "trait_element": "Elemento",
  "trait_aura": "Aura",
  "trait_background": "Fondo",
  "prev": "Ant.",
  "next": "Sig.",
  "all": "Todos",
  "save": "Guardar",
  "risk_lock": "Bloqueo de riesgo",
  "max_position": "Posición máx. %",
  "trailing_stop": "Límite dinámico %",
  "take_profit": "Objetivo de ganancias %",
  "stop_loss": "Límite de pérdidas %",
  "risk_strategy": "Riesgo y estrategia",
  "exchanges": "Conexiones de exchange",
  "connected": "Conectado",
  "disconnected": "No conectado",
  "withdraw_demo_wallet": "Retirar (wallet demo)",
  "withdraw_fee_note": "Retirar antes de 7 días desde tu último depósito aplica una comisión del 5% por retiro anticipado (parte del propietario).",
  "withdraw": "Retirar",
  "trade_history": "Historial de operaciones",
  "no_closed_trades": "Aún no hay operaciones cerradas",
  "owner_subtitle": "Rendimiento de todos los usuarios, solo lectura · registro de comisiones (2% por operación rentable, liquidación semanal · 5% de comisión por retiro anticipado)",
  "total_users": "Usuarios totales",
  "total_commission": "Comisión total",
  "this_week": "Esta semana",
  "total_volume": "Volumen total",
  "all_time": "histórico",
  "settles_weekly": "se liquida semanalmente",
  "commission_breakdown": "Desglose de comisiones",
  "from_trade_profits": "De beneficios de operaciones (2%)",
  "from_withdrawal_fees": "De comisiones por retiro anticipado (5%)",
  "owner_rate": "Tasa del propietario",
  "settlement": "Liquidación",
  "early_exit_fee": "Comisión por salida anticipada",
  "weekly": "Semanal",
  "daily_accrual": "Devengo diario",
  "no_commission_yet": "Aún no hay comisiones — se generan con las operaciones rentables.",
  "users_performance": "Rendimiento de usuarios (solo lectura)",
  "col_user": "Usuario",
  "col_role": "Rol",
  "col_joined": "Se unió",
  "col_volume": "Volumen",
  "col_balance": "Saldo",
  "role_owner": "propietario",
  "role_user": "usuario",
  "guide_intro": "Te damos la bienvenida a Firebird AI Trade. Sigue estos pasos para empezar con seguridad.",
  "guide_step": "Paso",
  "guide1_title": "El modo demo está activado",
  "guide1_desc": "Empiezas con un saldo demo de $100. No se usa dinero real hasta que actives explícitamente el trading real con tus propias claves seguras.",
  "guide2_title": "Lee el panel",
  "guide2_desc": "Consulta el valor de la cartera, las mejores señales de IA, el resumen del mercado, la actividad de ballenas y el pulso del mercado en un solo lugar.",
  "guide3_title": "Revisa las señales de IA",
  "guide3_desc": "Las monedas se puntúan de 0 a 100 con RSI, cruces de SMA y momentum en distintos marcos temporales.",
  "guide4_title": "Pregunta al asistente de IA",
  "guide4_desc": "Obtén la puntuación de una moneda con estrategia de entrada/salida y notas de riesgo de Firebird AI Core (GPT-5.6).",
  "guide5_title": "Prueba el Auto-Trade (demo)",
  "guide5_desc": "Deja que el bot abra posiciones de COMPRA con señales fuertes y las gestione con trailing stop / take-profit.",
  "guide6_title": "Escanea memecoins",
  "guide6_desc": "Solo se muestran memecoins operables con altas puntuaciones de seguridad — sin tokens desconocidos ni fraudulentos.",
  "guide7_title": "Explora los NFT de Firebird 555",
  "guide7_desc": "Explora la colección de 555 fénix con 6 raras legendarias.",
  "disclaimer": "Modo demo/sandbox. Nada de esto es asesoramiento financiero. Ningún sistema puede garantizar tasas de acierto futuras.",
  "src_manual": "Manual",
  "src_auto": "Automático",
  "tier_legendary": "Legendario",
  "tier_epic": "Épico",
  "tier_rare": "Raro",
  "tier_common": "Común",
  "verdict_tradeable": "Operable",
  "verdict_watch": "Vigilar",
  "pressure_accumulation": "Acumulación",
  "pressure_distribution": "Distribución",
  "reason_take_profit": "Objetivo de ganancias",
  "reason_liquidation": "Liquidación",
  "reason_stop_loss": "Límite de pérdidas",
  "reason_trailing_take_profit": "Take Profit móvil",
  "reason_trailing_stop": "Stop móvil",
  "reason_signal_flip": "Cambio de señal",
  "welcome": "Bienvenido",
  "trader": "operador",
  "live": "En vivo",
  "verify_email_banner": "Verifica tu correo para abrir operaciones. Revisa tu bandeja de entrada para encontrar el enlace de verificación.",
  "resend": "Reenviar",
  "verification_sent": "Correo de verificación enviado",
  "could_not_resend": "No se pudo reenviar",
  "search_coin_placeholder": "Busca cualquier moneda (p. ej. BTC, PEPE, ARB)",
  "add_to_watchlist": "Añadir a la lista de seguimiento",
  "free_balance": "Saldo libre",
  "in_positions": "En posiciones",
  "total_equity": "Patrimonio total",
  "watchlist": "Lista de seguimiento",
  "watchlist_empty": "Aún no hay monedas — busca y pulsa + para añadir.",
  "high_exposure": "Usando el {percent}% de tu saldo libre — exposición alta.",
  "advanced_tpsl": "TP / SL avanzado",
  "entry_optional": "Entrada (opcional — por defecto a mercado)",
  "market": "mercado",
  "take_profit_price": "Precio de Take Profit",
  "stop_loss_price": "Precio de Stop Loss",
  "tp_example": "p. ej. 72000",
  "sl_example": "p. ej. 66000",
  "if_tp_hits": "Si se alcanza el TP",
  "if_sl_hits": "Si se alcanza el SL",
  "pnl_preview_note": "Basado en ${amount} de margen × {leverage}x. Líneas dibujadas en el gráfico →",
  "clear_tpsl": "Borrar TP/SL",
  "one_tap_trade": "Operación con un toque",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "Señales automáticas",
  "add_token_placeholder": "Añade cualquier token (p. ej., ARB, OP, TIA)",
  "analyze": "Analizar",
  "analyzing_on": "Analizando {symbol} en {tf}…",
  "tap_to_load": "Toca para cargar en el gráfico →",
  "scanning_market": "Escaneando el mercado…",
  "no_signals": "Aún no hay señales.",
  "money_depth": "Flujo de dinero",
  "sr_zones": "Zonas S/R",
  "bot_analysis": "Análisis del bot",
  "confidence": "Confianza",
  "reasoning": "Razonamiento",
  "tp_label": "Take Profit",
  "sl_label": "Stop Loss",
  "risk_reward": "Riesgo : Beneficio",
  "levels_from_position": "Niveles en vivo de tu posición abierta",
  "levels_suggested": "Niveles sugeridos · no es asesoramiento financiero",
  "toast_opened": "Posición {symbol} {leverage}x abierta",
  "toast_closed": "{symbol} cerrada · PnL ${pnl}",
  "toast_closed_pnl": "Cerrada · PnL ${pnl}",
  "ago_s": "hace {n} s",
  "ago_m": "hace {n} min",
  "ago_h": "hace {n} h",
  "ago_d": "hace {n} d",
  "in_label": "Entrada",
  "out_label": "Salida",
  "confirm_reveal_email": "¿Mostrar el correo de este usuario? Los correos son privados — consúltalo solo cuando sea necesario.",
  "view_email_private": "Ver correo (privado)",
  "display_name_updated": "Nombre visible actualizado",
  "change_email_sent": "Enlace de verificación enviado al nuevo correo",
  "username_updated": "Nombre de usuario actualizado",
  "password_changed": "Contraseña cambiada. Vuelve a iniciar sesión en tus otros dispositivos.",
  "confirm_logout_all": "¿Cerrar sesión en todos los dispositivos? Tendrás que iniciar sesión de nuevo.",
  "no_wallet": "No se detectó ninguna extensión de wallet (MetaMask/WalletConnect).",
  "wallet_rejected": "Conexión de wallet rechazada.",
  "profile_security": "Perfil y seguridad",
  "display_name": "Nombre visible",
  "display_name_optional": "Nombre visible (opcional)",
  "edit": "Editar",
  "cancel": "Cancelar",
  "change": "Cambiar",
  "in_days": "En {days} d",
  "username_label": "Nombre de usuario",
  "username_hint": "De 3 a 20 letras, números o guion bajo. Se puede cambiar una vez cada 30 días.",
  "username_example": "p. ej. arash_king",
  "email_private": "Correo (privado)",
  "change_email": "Cambiar correo",
  "unverified": "Sin verificar",
  "resend_verification": "Reenviar verificación",
  "new_email": "Nuevo correo",
  "current_password": "Contraseña actual",
  "new_password": "Nueva contraseña",
  "confirm_new_password": "Confirmar nueva contraseña",
  "send_verification_new": "Enviar verificación al nuevo correo",
  "change_email_hint": "Confirmarás mediante un enlace enviado al nuevo correo y luego volverás a iniciar sesión.",
  "email_private_hint": "Tu correo nunca se muestra públicamente. Solo tú puedes verlo aquí.",
  "sessions": "Sesiones",
  "logout_all_devices": "Cerrar sesión en todos los dispositivos",
  "change_password": "Cambiar contraseña",
  "pw_hint": "Mín. 8 caracteres, una letra y un número.",
  "update_password": "Actualizar contraseña",
  "coin_example_placeholder": "p. ej. BTC, PEPE, TAO...",
  "username_or_email": "Usuario o correo",
  "forgot_password_q": "¿Olvidaste tu contraseña?",
  "invalid_email": "Introduce un correo válido",
  "pw_mismatch": "Las contraseñas no coinciden",
  "username_hint_short": "De 3 a 20 letras, números o guion bajo",
  "account_created_verify": "¡Cuenta creada! Revisa tu correo para verificar tu cuenta.",
  "confirm_password_label": "Confirmar contraseña",
  "missing_verify_token": "Falta el token de verificación.",
  "email_verified_msg": "¡Correo verificado!",
  "verification_failed": "Falló la verificación.",
  "verifying_email": "Verificando tu correo…",
  "email_verified_title": "Correo verificado",
  "go_to_login": "Ir al inicio de sesión",
  "verification_failed_title": "Falló la verificación",
  "verify_expired_hint": "¿El enlace expiró? Inicia sesión y usa «Reenviar verificación» en Ajustes.",
  "back_to_login": "← Volver al inicio de sesión",
  "forgot_password": "Contraseña olvidada",
  "forgot_subtitle": "Introduce tu usuario o correo y te enviaremos un enlace de restablecimiento.",
  "forgot_sent_toast": "Si la cuenta existe, se ha enviado un enlace de restablecimiento.",
  "forgot_sent_full": "Si la cuenta existe, se ha enviado un enlace de restablecimiento. Revisa tu correo (válido 15 minutos).",
  "send_reset_link": "Enviar enlace de restablecimiento",
  "remembered_it": "¿Ya la recuerdas?",
  "missing_reset_token": "Falta el token de restablecimiento. Usa el enlace de tu correo.",
  "pw_requirement": "La contraseña debe tener al menos 8 caracteres e incluir una letra y un número",
  "password_updated": "Contraseña actualizada.",
  "reset_password": "Restablecer contraseña",
  "reset_subtitle": "Elige una nueva contraseña para tu cuenta.",
  "reset_invalid": "Enlace de restablecimiento no válido o ausente. Solicita uno nuevo.",
  "request_reset_link": "Solicitar enlace de restablecimiento",
  "new_password_label": "Nueva contraseña",
  "pw_hint2": "Al menos 8 caracteres, con una letra y un número.",
  "update_password_btn": "Actualizar contraseña",
  "bullish": "Alcista",
  "bearish": "Bajista",
  "inflow": "entrada",
  "outflow": "salida",
  "volume_up": "Volumen al alza",
  "volume_down": "Volumen a la baja",
  "money_flow_mfi": "Flujo de dinero (MFI 14)",
  "flow_overbought": "Sobrecompra",
  "flow_oversold": "Sobreventa",
  "flow_bullish": "Entrada alcista",
  "flow_bearish": "Salida bajista",
  "support": "Soporte",
  "resistance": "Resistencia",
  "available_for_trade": "Disponible para operar",
  "free_balance_after": "Saldo libre después",
  "tab_major": "Principales",
  "tab_shitcoins": "Monedas basura",
  "tab_nfts": "NFT",
  "filter_direction": "Dirección",
  "buy_only": "Solo compra",
  "sell_only": "Solo venta",
  "min_confidence": "Confianza mín.",
  "confirm": "Confirmar",
  "safety_score": "Puntuación de seguridad",
  "liquidity_lock": "Bloqueo de liquidez",
  "locked": "Bloqueada",
  "unlocked": "Desbloqueada",
  "honeypot": "Trampa",
  "honeypot_safe_label": "Seguro",
  "honeypot_risk": "Riesgo",
  "nft_demo_notice": "Operación demo — no se comprará ningún NFT real",
  "view_on_opensea": "Ver en OpenSea",
  "volume_24h": "Volumen (24 h)",
  "nft_position_opened": "Posición NFT abierta (demo)",
  "crypto_positions_title": "Posiciones de cripto y shitcoins",
  "nft_positions_title": "Posiciones NFT",
  "min_safety_required": "La puntuación de seguridad debe ser ≥ 75 para operar",
  "amount_exceeds_balance": "El importe supera tu saldo libre",
  "amount_gt_zero": "El importe debe ser mayor que 0",
  "confirm_trade": "Confirmar operación",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "No hay posiciones NFT abiertas",
  "floor": "Precio mínimo",
  "rr_short": "R:B",
  "best_marketplace": "Mejor mercado",
  "story": "Historia",
  "show_more": "Ver más",
  "show_less": "Ver menos",
  "view_chart": "Ver gráfico",
  "reason_sma_bull": "SMA9 por encima de SMA21 (tendencia alcista)",
  "reason_sma_bear": "SMA9 por debajo de SMA21 (tendencia bajista)",
  "reason_rsi_oversold": "sobrevendido",
  "reason_rsi_overbought": "sobrecomprado",
  "reason_rsi_neutral": "neutral",
  "reason_pos_momentum": "Momentum positivo",
  "reason_neg_momentum": "Momentum negativo",
  "reason_insufficient": "Datos insuficientes",
  "reason_whale_accum": "Acumulación de ballenas",
  "reason_rising_floor": "Precio mínimo al alza",
  "reason_falling_floor": "Precio mínimo a la baja",
  "reason_high_rarity": "Rareza alta",
  "reason_mid_rarity": "Rareza media",
  "nft_trade_history": "Historial de operaciones NFT",
  "no_nft_trades": "Aún no hay operaciones NFT cerradas",
  "entry_floor": "Precio mínimo de entrada",
  "exit_floor": "Precio mínimo de salida",
  "verify_reminder": "Tu correo aún no está verificado — verifícalo para desbloquear el trading.",
  "verify_now": "Verificar ahora",
  "dismiss": "Descartar",
  "trusted_devices": "Sesiones activas · Dispositivos conectados",
  "font_size": "Tamaño de fuente",
  "font_small": "Pequeño",
  "font_medium": "Mediano",
  "font_large": "Grande",
  "sessions_hint": "Teléfonos y navegadores con sesión iniciada en tu cuenta (no son claves API de exchange).",
  "unknown_device": "Dispositivo desconocido",
  "this_device": "Este dispositivo",
  "current_session": "Actual",
  "last_active": "Última actividad",
  "revoke_all_others": "Cerrar sesión en todos los demás dispositivos",
  "revoke_all_others_done": "Sesión cerrada en todos los demás dispositivos",
  "no_other_devices": "No hay otros dispositivos activos",
  "device_revoked": "Dispositivo desconectado",
  "ui_logo_alt": "Logotipo de trading Firebird / Simorgh",
  "ui_logo_switch_hint": "Toca para cambiar el logotipo",
  "ui_vpn_info": "Información de VPN"
};
export default es;
